import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Building2 } from 'lucide-react';
import { companyLabel } from '../client360/c360Shared';
import { mesLabel, shiftMonth } from '../comercial360/com360Shared';

const Stat = ({ label, value, testId }) => (
  <div className="px-4 py-2 rounded-xl bg-white/10" data-testid={testId}>
    <div className="text-2xl font-bold font-[Outfit]">{value}</div>
    <div className="text-[11px] uppercase tracking-wider text-white/70">{label}</div>
  </div>
);

export const EmpresaHeader = ({ d, month, setMonth }) => (
  <div className="rounded-2xl bg-[#2D3E6F] text-white p-6 flex flex-col lg:flex-row lg:items-end gap-6 justify-between" data-testid="emp360-header">
    <div className="space-y-3 min-w-0">
      <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#4DD4E8]">
        <Building2 className="w-4 h-4" />Página da Empresa
        <Link to="/empresas/360" className="normal-case tracking-normal text-white/70 hover:text-white underline" data-testid="emp360-all-link">ver todas</Link>
      </div>
      <h1 className="text-3xl sm:text-4xl font-bold font-[Outfit]" data-testid="emp360-name">{companyLabel(d.empresa.company)}</h1>
      <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-2 py-1">
        <button onClick={() => setMonth(shiftMonth(month, -1))} className="p-1 rounded-full hover:bg-white/10" data-testid="emp360-month-prev"><ChevronLeft className="w-4 h-4" /></button>
        <span className="text-sm font-semibold px-1" data-testid="emp360-month">{mesLabel(month)}</span>
        <button onClick={() => setMonth(shiftMonth(month, 1))} className="p-1 rounded-full hover:bg-white/10" data-testid="emp360-month-next"><ChevronRight className="w-4 h-4" /></button>
      </div>
    </div>
    <div className="flex flex-wrap gap-2">
      <Stat label="Clientes ativos" value={d.resumo.clientes_ativos} testId="emp360-stat-clientes" />
      <Stat label="Contratos (total)" value={d.resumo.contratos_total} testId="emp360-stat-contratos" />
      <Stat label="Anulados (total)" value={`${d.resumo.anulados_total} · ${d.resumo.anulados_pct_total}%`} testId="emp360-stat-anulados" />
    </div>
  </div>
);
